const language = require("../languages/fa.json");
import jmoment from "moment-jalaali";
import store from "../store";

class utils {
  validMobile = (mobile) => {
    mobile = mobile.trim();
    if (mobile.indexOf(" ") > -1) {
      return false;
    }
    if (mobile.length == 11 && mobile.charAt(0) == 0 && mobile.charAt(1) == 9) {
      return true;
    }
    return false;
  };

  monize = (x) => {
    if (Number(x) == 0) return 0;
    if (!x) return "";
    x = x.toString().replace(/,/g, "");
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  showErrors(vue, err) {
    let alertText = "";
    if (err.data.errors) {
      for (let i in err.data.errors) {
        alertText +=
          (alertText == "" ? "" : ",") +
          `${this.translate(err.data.errors[i])} `;
      }
    }
    vue.$swal.fire({
      title: "!خطا",
      text: `${alertText}`,
      icon: "error",
      confirmButtonText: "متوجه شدم",
    });
  }

  showSuccess(vue, msg = null) {
    vue.$swal.fire({
      title: "",
      text: msg ? msg : `عملیات با موفقیت انجام شد`,
      icon: "success",
      // confirmButtonText: "متوجه شدم",
      position: 'center',
      showConfirmButton: false,
      timer: 2000
    });
  }

  getCartCount(cart) {
    let out = 0;
    const orderDetails = cart.orderDetail;
    for (let i in orderDetails) {
      if (orderDetails[i].all_videos_buy == 1) {
        out++;
      } else {
        out += orderDetails[i].productDetails.length;
      }
    }
    return out;
  }

  translate(input) {
    if (!language[input]) {
      return input;
    }
    return language[input];
  }

  perToEn = (str) => {
    var unFixNumbers = String(str);
    unFixNumbers = unFixNumbers.replace(/۰/g, "0");
    unFixNumbers = unFixNumbers.replace(/۱/g, "1");
    unFixNumbers = unFixNumbers.replace(/۲/g, "2");
    unFixNumbers = unFixNumbers.replace(/۳/g, "3");
    unFixNumbers = unFixNumbers.replace(/۴/g, "4");
    unFixNumbers = unFixNumbers.replace(/۵/g, "5");
    unFixNumbers = unFixNumbers.replace(/۶/g, "6");
    unFixNumbers = unFixNumbers.replace(/۷/g, "7");
    unFixNumbers = unFixNumbers.replace(/۸/g, "8");
    unFixNumbers = unFixNumbers.replace(/۹/g, "9");
    //-------------apple
    unFixNumbers = unFixNumbers.replace(/٠/g, "0");
    unFixNumbers = unFixNumbers.replace(/١/g, "1");
    unFixNumbers = unFixNumbers.replace(/٢/g, "2");
    unFixNumbers = unFixNumbers.replace(/٣/g, "3");
    unFixNumbers = unFixNumbers.replace(/٤/g, "4");
    unFixNumbers = unFixNumbers.replace(/٥/g, "5");
    unFixNumbers = unFixNumbers.replace(/٦/g, "6");
    unFixNumbers = unFixNumbers.replace(/٧/g, "7");
    unFixNumbers = unFixNumbers.replace(/٨/g, "8");
    unFixNumbers = unFixNumbers.replace(/٩/g, "9");
    return unFixNumbers;
  };

  toJalali(inp) {
    return jmoment(inp).format("jYYYY/jMM/jDD");
  }

  afterSuccessLogin(response) {
    store.commit("set", ["token", response.data.access_token]);
    store.commit("set", ["user_id", response.data.user_id]);
    store.commit("set", ["menus", response.data.menus]);
    store.commit("set", ["menuActiveId", response.data.menus[1].id]);
    store.commit("set", ["userGroupType", response.data.group.type]);
    store.commit("set", [
      "fullName",
      `${response.data.first_name ? response.data.first_name : ""} ${
        response.data.last_name ? response.data.last_name : ""
      }`,
    ]);
    store.commit("set", [
      "socket",
      {
        isConnected: false,
        message: "",
        reconnectError: false,
      },
    ]);
  }
}

export default utils;
// export default {
//   install: (app) => {
//     app.config.globalProperties.$utils = new utils;
//   }
// };
